import { render, staticRenderFns } from "./Palata.vue?vue&type=template&id=c03e2694"
import script from "./Palata.vue?vue&type=script&lang=js"
export * from "./Palata.vue?vue&type=script&lang=js"
import style0 from "./Palata.vue?vue&type=style&index=0&id=c03e2694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports